import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectsQuery } from "../../features/api/Projects/projectsApi";
import { useEditTaskMutation } from "../../features/api/Tasks/tasksApi";
import { useGetTeamMembersQuery } from "../../features/api/teamMembers/teamMembersApi";
import Error from "../ui/Error";

export default function Form({ task }) {
  const navigate = useNavigate();

  const {
    taskName,
    teamMember,
    project: initialProject,
    deadline: initialDeadline,
    id,
  } = task || {};

  const [editTask, { isLoading, isError, error, isSuccess }] =
    useEditTaskMutation();

  const { data: projects } = useGetProjectsQuery() || {};
  const { data: members } = useGetTeamMembersQuery() || {};

  const [title, setTitle] = useState(taskName);
  const [assign, setAssign] = useState(teamMember.name);
  const [project, setProject] = useState(initialProject.projectName);
  const [deadline, setDeadline] = useState(initialDeadline);

  const resetForm = () => {
    setTitle("");
    setAssign("");
    setProject("");
    setDeadline("");
  };

  useEffect(() => {
    if (isSuccess) {
      resetForm();
      navigate("/");
    }
  }, [isSuccess, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const projectInfo = projects?.find(
      (projectItem) => projectItem.projectName === project
    );
    const memberInfo = members?.find((member) => member.name === assign);

    editTask({
      id,
      data: {
        taskName: title,
        teamMember: memberInfo,
        project: projectInfo,
        deadline: deadline,
      },
    });
  };

  return (
    <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="fieldContainer">
          <label htmlFor="lws-taskName">Task Name</label>
          <input
            type="text"
            name="taskName"
            id="lws-taskName"
            required
            placeholder="Implement RTK Query"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className="fieldContainer">
          <label>Assign To</label>
          <select
            name="teamMember"
            id="lws-teamMember"
            required
            value={assign}
            onChange={(e) => setAssign(e.target.value)}
          >
            <option defaultValue hidden>
              Select Job
            </option>
            <option>Sumit Saha</option>
            <option>Saad Hasan</option>
            <option>Akash Ahmed</option>
            <option>Md Salahuddin</option>
            <option>Riyadh Hassan</option>
            <option>Ferdous Hassan</option>
            <option>Arif Almas</option>
          </select>
        </div>
        <div className="fieldContainer">
          <label htmlFor="lws-projectName">Project Name</label>
          <select
            id="lws-projectName"
            name="projectName"
            required
            value={project}
            onChange={(e) => setProject(e.target.value)}
          >
            <option defaultValue hidden>
              Select Project
            </option>
            <option>Scoreboard</option>
            <option>Flight Booking</option>
            <option>Product Cart</option>
            <option>Book Store</option>
            <option>Blog Application</option>
            <option>Job Finder</option>
          </select>
        </div>

        <div className="fieldContainer">
          <label htmlFor="lws-deadline">Deadline</label>
          <input
            type="date"
            name="deadline"
            id="lws-deadline"
            required
            value={deadline}
            onChange={(e) => setDeadline(e.target.value)}
          />
        </div>

        <div className="text-right">
          <button disabled={isLoading} type="submit" className="lws-submit">
            Save
          </button>
        </div>
      </form>
      {isError && <Error message={error?.data} />}
    </div>
  );
}
